import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/app/new-about/page.tsx");
